import React, {useEffect, useMemo, useRef, useState} from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import omtIcon from '../../theme/assets/svg/lp_omt_icon.svg';
import indexIcon from '../../theme/assets/svg/lp_index_icon.svg';
import backArrow from '../../theme/assets/svg/lp_back_arrow.svg';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Moment from "react-moment";
import {closeFreeze, getFreezeHistory, setExtendFreezeModalStatus} from "../../store/cabinet/action";

const LaunchpadFreezeHistory = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const freezeHistory = useSelector(store => store.cabinet.freezeHistory);

    const [currentFilter, setCurrentFilter] = useState(false);
    const [dropStatus, setDropStatus] = useState(false);

    const dropHandler = (status) => {
        setCurrentFilter(status);
        setDropStatus(false);
        // сброс на первую страницу при смене фильтра
        dispatch(getFreezeHistory(status, 1, { append: false }));
        // прокрутка контейнера вверх
        boxRef.current?.scrollTo?.({ top: 0, behavior: 'auto' });
    };

    const itemStatusText = (status) => {
        switch (status) {
            case 'active':    return t('В процессе');
            case 'pending':   return t('На подтверждении');
            case 'completed': return t('В ожидании');
            case 'closed':    return t('Завершен');
            case 'canceled':  return t('Отменен');
            default:          return t('—');
        }
    };

    const filterTextHandler = (status) => {
        switch (status) {
            case 'active':    return t('В процессе');
            case 'pending':   return t('На подтверждении');
            case 'completed': return t('В ожидании');
            case 'closed':    return t('Завершен');
            case 'canceled':  return t('Отменен');
            default:          return t('Все');
        }
    };

    const statusHandler = (status) => {
        switch (status) {
            case 'active':    return Styles.inProcess;
            case 'completed': return Styles.inPending;
            case 'pending':   return Styles.inProcess;
            case 'closed':    return Styles.inCompleted;
            case 'canceled':  return Styles.inCanceled;
            default:          return Styles.inProcess;
        }
    };

    const daysHandler = (dateStr) => {
        const [y, m, d] = dateStr.split('-').map(Number);
        const target = new Date(y, m - 1, d); // локальная полночь целевой даты
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const diffMs = target - today;
        const days = Math.ceil(diffMs / 86400000);
        return Math.max(0, days);
    };

    // ---- мета пагинации из Laravel-пагинатора ----
    const meta = useMemo(() => {
        const box = freezeHistory?.freezes || {};
        const page     = box.current_page ?? 1;
        const lastPage = box.last_page ?? 1;
        const hasMore  = !!box.next_page_url;      // есть ли следующая страница
        const nextPage = hasMore ? page + 1 : null;
        const data     = box.data ?? [];
        const loading  = freezeHistory?.loading ?? false; // если ведёшь лоадер в сторе
        return { page, lastPage, hasMore, nextPage, data, loading };
    }, [freezeHistory]);

    // ---- контейнер для скролла и локальная блокировка загрузки ----
    const boxRef = useRef(null);
    const loadingRef = useRef(false);
    useEffect(() => { loadingRef.current = !!meta.loading; }, [meta.loading]);

    // первичная загрузка при маунте
    useEffect(() => {
        if (!meta.data?.length) {
            dispatch(getFreezeHistory(currentFilter, 1, { append: false }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadMore = () => {
        if (loadingRef.current) return;
        if (!meta.hasMore || !meta.nextPage) return;

        loadingRef.current = true;
        const p = dispatch(getFreezeHistory(currentFilter, meta.nextPage, { append: true }));
        if (p && typeof p.finally === 'function') {
            p.finally(() => { loadingRef.current = false; });
        } else {
            setTimeout(() => { loadingRef.current = false; }, 300);
        }
    };

    // слушатель скролла именно на freezeBox
    useEffect(() => {
        const el = boxRef.current;
        if (!el) return;

        const threshold = 120; // пикселей до низа
        const onScroll = () => {
            const { scrollTop, clientHeight, scrollHeight } = el;
            if (scrollTop + clientHeight >= scrollHeight - threshold) {
                loadMore();
            }
        };

        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [boxRef, meta.nextPage, meta.hasMore, currentFilter]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.backRow}`}>
                    <div className={`${Styles.backBtn}`} onClick={()=>{navigate('/launchpad')}}>
                        <div className={`${Styles.backBtnImgWrap}`}>
                            <img src={backArrow} alt={t('Назад')}/>
                        </div>
                        <div className={`${Styles.backBtnText}`}>{t('Назад')}</div>
                    </div>
                </div>

                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxTitleRow}`}>
                        <div className={`${Styles.contentBoxTitle}`}>{t('История заморозок')}</div>

                        <div className={`${Styles.filterWrap} ${dropStatus ? Styles.filterWrapActive : ''}`}>
                            <div
                                className={`${Styles.filterWrapCurrentBox}`}
                                onClick={()=> setDropStatus(!dropStatus)}
                            >
                                <div className={`${Styles.filterWrapCurrentImgWrap}`}>
                                    <img src={backArrow} alt="dropdown"/>
                                </div>
                                <div className={`${Styles.filterWrapCurrent}`}>
                                    {filterTextHandler(currentFilter)}
                                </div>

                                <div className={`${Styles.absFilterWrap}`}>
                                    <div className={`${Styles.absFilterWrapItem}`} onClick={()=>{dropHandler(false)}}>{t('Все')}</div>
                                    <div className={`${Styles.absFilterWrapItem}`} onClick={()=>{dropHandler('active')}}>{t('В процессе')}</div>
                                    <div className={`${Styles.absFilterWrapItem}`} onClick={()=>{dropHandler('pending')}}>{t('На подтверждении')}</div>
                                    <div className={`${Styles.absFilterWrapItem}`} onClick={()=>{dropHandler('completed')}}>{t('В ожидании')}</div>
                                    <div className={`${Styles.absFilterWrapItem}`} onClick={()=>{dropHandler('closed')}}>{t('Завершен')}</div>
                                    <div className={`${Styles.absFilterWrapItem}`} onClick={()=>{dropHandler('canceled')}}>{t('Отменен')}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* === SCROLL CONTAINER (должен иметь фикс. высоту и overflow:auto в CSS) === */}
                    <div className={`${Styles.freezeBox}`} ref={boxRef}>
                        {meta.data?.length > 0 ? meta.data.map((item, index) => (
                            <div className={`${Styles.freezeBoxItem} ${statusHandler(item.status)}`} key={`freezeItem${item.id || index}`}>
                                <div className={`${Styles.freezeBoxItemTitleRow}`}>
                                    <div className={`${Styles.freezeBoxItemTitleRowImgWrap}`}>
                                        <img src={item?.is_index ? indexIcon : omtIcon} alt={item?.is_index ? 'Index OMT20' : 'OMT'}/>
                                    </div>
                                    <div className={`${Styles.freezeBoxItemTitleBox}`}>
                                        <div className={`${Styles.freezeBoxItemTitle}`}>{item?.is_index ? 'Index OMT20' : 'OMT'}</div>
                                        <div className={`${Styles.freezeBoxItemSubTitle}`}>Oracle Meta Technolgy</div>
                                    </div>
                                </div>

                                <div className={`${Styles.freezeBoxItemInfo}`}>
                                    <div className={`${Styles.freezeBoxItemInfoRow}`}>
                                        <div className={`${Styles.freezeBoxItemInfoRowName}`}>{t('Дата начала')}</div>
                                        <div className={`${Styles.freezeBoxItemInfoRowValue}`}>
                                            <Moment format="DD/MM/YYYY">{item.created_at}</Moment>
                                        </div>
                                    </div>
                                    <div className={`${Styles.freezeBoxItemInfoRow}`}>
                                        <div className={`${Styles.freezeBoxItemInfoRowName}`}>{t('Сумма')}</div>
                                        <div className={`${Styles.freezeBoxItemInfoRowValue}`}>{item.amount * 1}</div>
                                    </div>
                                    <div className={`${Styles.freezeBoxItemInfoRow}`}>
                                        <div className={`${Styles.freezeBoxItemInfoRowName}`}>{t('Оставшееся время')}</div>
                                        <div className={`${Styles.freezeBoxItemInfoRowValue}`}>
                                            {item.status === 'closed' ? '-' : daysHandler(item.expires_at)} {item.status === 'closed' ? '' : t('дней')}
                                        </div>
                                    </div>
                                </div>

                                <div className={`${Styles.freezeBoxItemBtnsWrap}`}>
                                    <div
                                        className={`${Styles.freezeBoxItemBtn}`}
                                        onClick={()=>{
                                            if (item.status === 'completed'){
                                                dispatch(setExtendFreezeModalStatus({status: true, id: item.id}));
                                            }
                                        }}
                                    >
                                        {t('Продлить')}
                                    </div>
                                    <div
                                        className={`${Styles.freezeBoxItemBtn}`}
                                        onClick={()=>{
                                            if (item.status === 'completed'){
                                                dispatch(closeFreeze(item.id));
                                            }
                                        }}
                                    >
                                        {t('Вывести')}
                                    </div>
                                    <div className={Styles.freezeBoxItemCompleted}>
                                        {itemStatusText(item.status)}
                                    </div>
                                </div>
                            </div>
                        )) : (
                            <div className={`${Styles.freezeEmpty}`}>{t('На данный момент у вас нет активных средств в заморозке!')}</div>
                        )}

                        {/* нижний индикатор подгрузки */}
                        {meta.hasMore && (
                            <div className={Styles.freezeBoxLoader}>
                                {/* optional: спиннер/скелетон */}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LaunchpadFreezeHistory;

